module.exports = __webpack_public_path__ + "static/media/195.3e926acb.webp";